"use client";

import Link from "next/link";
import { SITE_CONFIG } from "../../lib/site-config";

export default function SupportClient() {
  return (
    <main className="max-w-4xl mx-auto px-4 py-16">
      {/* ================= HEADER ================= */}
      <div className="mb-12 text-center">
        <h1 className="text-3xl font-semibold">Support</h1>
        <p className="text-sm text-gray-500 mt-2">
          We’re here to help you with any questions or issues.
        </p>
      </div>

      {/* ================= CONTENT ================= */}
      <div className="space-y-10">
        {/* CONTACT SUPPORT */}
        <section className="border rounded-xl p-6 bg-white">
          <h2 className="text-lg font-semibold mb-2">Contact Support</h2>
          <p className="text-sm text-gray-700 mb-4">
            Reach out to our support team for assistance with orders, products,
            warranty, or technical issues.
          </p>

          <ul className="text-sm text-gray-700 space-y-2">
            <li>
              📞 Phone:{" "}
              <span className="font-medium">{SITE_CONFIG.phone}</span>
            </li>
            <li>
              📧 Email:{" "}
              <a
                href={`mailto:${SITE_CONFIG.email}`}
                className="text-blue-600 hover:underline"
              >
                {SITE_CONFIG.email}
              </a>
            </li>
            {SITE_CONFIG.operatingHours && (
              <li>
                ⏰ Support Hours:{" "}
                <span className="font-medium">
                  {SITE_CONFIG.operatingHours}
                </span>
              </li>
            )}
          </ul>
        </section>

        {/* QUICK HELP */}
        <section className="border rounded-xl p-6 bg-gray-50">
          <h2 className="text-lg font-semibold mb-3">Quick Help</h2>

          <ul className="space-y-3 text-sm">
            <li>
              <Link
                href="/returns"
                className="text-blue-600 hover:underline"
              >
                Refund & Return Policy
              </Link>
            </li>
            <li>
              <Link
                href="/delivery"
                className="text-blue-600 hover:underline"
              >
                Online Delivery Information
              </Link>
            </li>
            <li>
              <Link
                href="/warranty"
                className="text-blue-600 hover:underline"
              >
                Warranty Policy
              </Link>
            </li>
            <li>
              <Link
                href="/privacy-policy"
                className="text-blue-600 hover:underline"
              >
                Privacy Policy
              </Link>
            </li>
          </ul>
        </section>

        {/* STORE VISIT */}
        <section className="border rounded-xl p-6 bg-white">
          <h2 className="text-lg font-semibold mb-2">Visit Our Store</h2>
          <p className="text-sm text-gray-700">
            For in-person support, product inspection, or consultations, visit
            our physical store during business hours.
          </p>

          <p className="mt-3 text-sm text-gray-700 whitespace-pre-line">
            📍 Head Office: <br />
            {SITE_CONFIG.address}
          </p>

          <Link
            href="/contact-us"
            className="inline-block mt-4 text-blue-600 text-sm font-medium hover:underline"
          >
            Find Store Locations →
          </Link>
        </section>

        {/* COMMON QUESTIONS - AEO/GEO Optimized */}
        <section className="border rounded-xl p-6 bg-white shadow-sm">
          <h2 className="text-lg font-semibold mb-6">Common Questions</h2>
          <div className="space-y-6">
            {[
              { q: "How can I track my order?", a: "Once your order is shipped, you will receive a tracking ID via SMS and email. You can use this ID on our delivery partner's website or contact our support team for live updates." },
              { q: "What is the warranty process?", a: "To claim a warranty, bring the product and proof of purchase to our service center. We facilitate manufacturer warranty claims for all genuine products sold on our platform." },
              { q: "Do you offer home delivery outside Dhaka?", a: "Yes, we provide nationwide delivery across Bangladesh. Standard delivery takes 2-3 business days outside Dhaka, while inside Dhaka is usually within 24 hours." }
            ].map((item, idx) => (
              <div key={idx} className="group">
                <h3 className="font-bold text-slate-900 mb-2">{item.q}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{item.a}</p>
              </div>
            ))}
          </div>
        </section>

        {/* NOTE */}
        <section className="text-xs text-gray-500 text-center">
          For faster resolution, please keep your order number or product
          details ready when contacting support.
        </section>
      </div>
    </main>
  );
}